import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllPlaces,
  getStateList
} from "../../redux/actions/indexActions";
import { toast } from "react-toastify";
const AddMerchant = () => {
  const [formData, setFormData] = useState({
    place_id: "",
    name: "",
    email: "",
    mobile: "",
    address: "",
    city_id: "",
    state_id: "",
    country: "",
    pincode: "",
    company_name: "",
    description: "",
    website_url: "",
    status: 1,
    thumbnail: "",
  });
  const [errors, setErrors] = useState({});
  const [cities, setCities] = useState([]);
  const {
    AuthReducer: { auth },
    indexReducer: { places, stateLists }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  useEffect(() => {
    dispatch(getAllPlaces(auth.token));
    dispatch(getStateList(auth.token));
  }, [auth]);

  const handleSubmit = () => {
    const form = new FormData();
    for (const key in formData) {
      form.append([key], formData[key]);
    }
    axios
      .post(`/api/admin/v1/add-merchant`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };

  useEffect(() => {
    if (formData.state_id) {
      setFormData((prev) => ({ ...prev, city_id: "" }));
      axios(`/api/admin/v1/get-city/${formData.state_id}`)
        .then(({ data }) => {
          console.log(data, 'date');
          setCities(data?.data);
        })
        .catch((err) => console.error(err));
    } else {
      setCities([]);
    }
  }, [formData.state_id]);

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Merchant</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Place <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.place_id}
                type="select"
                name="place_id"
                onChange={inputHandler}
              >
                <option value="">Select Place</option>
                {places?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.place_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.place_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.name)}
                value={formData?.name}
                name="name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Email <span className="text-danger fs-4">*</span></Label>
              <Input
                type="email"
                invalid={Boolean(errors?.email)}
                value={formData?.email}
                name="email"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.email} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Mobile <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.mobile)}
                value={formData?.mobile}
                name="mobile"
                maxLength={10}
                onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}
              />
              <span className="d-block text-danger"> {errors?.mobile} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Address <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.address)}
                value={formData?.address}
                name="address"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.address} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>State</Label>
              <Input
                value={formData?.state_id}
                type="select"
                name="state_id"
                onChange={inputHandler}
              >
                <option value="">Select</option>
                {stateLists?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.state_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.state_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>City</Label>
              <Input
                value={formData?.city_id}
                type="select"
                name="city_id"
                onChange={inputHandler}
              >
                <option value="">Select</option>
                {cities?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.city_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.city_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Pincode</Label>
              <Input
                invalid={Boolean(errors?.pincode)}
                value={formData?.pincode}
                name="pincode"
                maxLength={6}
                onChange={(e) => !isNaN(e.target.value) && inputHandler(e)}
              />
              <span className="d-block text-danger"> {errors?.pincode} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Company Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.company_name)}
                value={formData?.company_name}
                name="company_name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.company_name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Website URL <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.website_url}
                invalid={Boolean(errors?.website_url)}
                name="website_url"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.website_url}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Thumbnail</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.thumbnail)}
                name="thumbnail"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.thumbnail}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Description</Label>
              <Input
                invalid={Boolean(errors?.description)}
                type="textarea"
                value={formData?.description}
                name="description"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.description} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMerchant;
